export class NotFoundException extends Error {
  constructor(message: string) {
    super(message);
  }
}

export class UniquenessViolationException extends Error {
  constructor(message: string) {
    super(message);
  }
}

export class IllegalArgumentException extends Error {
  constructor(message: string) {
    super(message);
  }
}

export class UndefinedConstructorException extends Error {
  constructor(message: string) {
    super(message);
  }
}
